import React from 'react';
import { useMediaQuery } from 'react-responsive';

const CheckoutOrBrowseProducts = ({
    primaryColor = '#008060',
    hoverColor = '#006d4f',
    textColor = '#ffffff',
}) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        marginTop: '20px',
        marginLeft: isMobile ? '0' : '17.5%'
    };

    const buttonStyle = {
        display: 'inline-block',
        width: '60%',
        padding: '12px 24px',
        margin: '10px 10%',
        borderRadius: '4px',
        backgroundColor: primaryColor,
        color: textColor,
        textDecoration: 'none',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '16px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    };

    const hoverStyle = {
        backgroundColor: hoverColor,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    };

    return (
        <div style={containerStyle}>
            <a
                href="/orders/new"
                style={buttonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = hoverStyle.boxShadow;
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = buttonStyle.boxShadow;
                }}
            >
                Checkout Now
            </a>
            <a
                href="/camps"
                style={buttonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = hoverStyle.boxShadow;
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = buttonStyle.boxShadow;
                }}
            >
                Camps
            </a>
            <a
                href="/products"
                style={buttonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = hoverStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = hoverStyle.boxShadow;
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = buttonStyle.backgroundColor;
                    e.currentTarget.style.boxShadow = buttonStyle.boxShadow;
                }}
            >
                Products
            </a>
        </div>
    );
};

export default CheckoutOrBrowseProducts;
